import React from 'react';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { useHistory } from 'react-router-dom';

// ITS-200. 방법론 진행 단계(등록됨 → 공개논평 → 승인 → 등록부 공개) 표시 및 단계 액션.
const STAGE_ORDER = ['REGISTERED', 'CONSULTATION', 'CONSULTATION_CLOSED', 'APPROVED', 'REGISTRY'];

const STAGE_LABELS = {
  REGISTERED: '등록됨 (비공개)',
  CONSULTATION: '공개논평 진행 중',
  CONSULTATION_CLOSED: '공개논평 종료 · 승인 대기',
  APPROVED: '정식 승인 (문서 미공개)',
  REGISTRY: '등록부 공개 (문서 포함)',
};

export const MethodologyStageSteps = (props) => {
  const { stage, consultation, status, isViewRegistry, attachedFile, documents, canEdit, onOpenConsultation, onToggleRegistry } =
    props;
  const history = useHistory();

  const activeStep = STAGE_ORDER.includes(stage) ? STAGE_ORDER.indexOf(stage) : 0;
  const hasOpenConsultation = !!(consultation && consultation.isCurrentlyOpen);
  const hasBasicDocument = !!(documents && documents.some((item) => item.type === 'BASIC'));

  const canOpenConsultation = canEdit && !status && !hasOpenConsultation && !!attachedFile;

  const renderOpenConsultationCaption = () => {
    if (canOpenConsultation) return null;
    // ITS-200(리뷰 반영). 승인된 방법론이 첨부파일까지 없는 경우 실제 차단 사유(승인 여부)가
    // 첨부파일 문구에 가려지지 않도록 hasOpenConsultation → status → !attachedFile 순으로 검사한다.
    if (hasOpenConsultation) return '진행 중인 공개논평이 있습니다';
    if (status) return '승인된 방법론은 공개논평을 개설할 수 없습니다';
    if (!attachedFile) return '저장된 첨부파일(제안서)이 있어야 개설할 수 있습니다';
    return null;
  };

  const renderApprovalGateCaption = () => {
    if (status) return null;
    if (!hasBasicDocument) return '정식 승인에는 기본 문서(BASIC) 1건 이상이 필요합니다';
    if (hasOpenConsultation) return '정식 승인 전에 공개논평을 먼저 종료해야 합니다';
    return null;
  };

  return (
    <article className='card-methodology-stage-steps'>
      <Stepper activeStep={activeStep} alternativeLabel>
        {STAGE_ORDER.map((item) => (
          <Step key={item}>
            <StepLabel>
              {STAGE_LABELS[item] || item}
              {item === 'CONSULTATION' && consultation && (
                <Typography variant='caption' component='div' color='text.secondary'>
                  {consultation.startDate} ~ {consultation.endDate}
                </Typography>
              )}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
      {!stage && (
        <Typography variant='caption' color='text.secondary'>
          단계 정보 없음
        </Typography>
      )}
      {stage && !STAGE_ORDER.includes(stage) && (
        <Typography variant='caption' color='text.secondary'>
          알 수 없는 단계: {stage}
        </Typography>
      )}
      {/* ITS-200(리뷰 반영). 공개논평 관리 이동은 읽기 전용 액션이므로 canEdit 여부와 무관하게 보인다. */}
      {consultation && (
        <div className='flex' style={{ marginTop: canEdit ? 0 : 20 }}>
          <Button variant='outlined' onClick={() => history.push('/consultation/detail/' + consultation.seq)}>
            공개논평 관리
          </Button>
        </div>
      )}
      {canEdit && (
        <div className='flex' style={{ marginTop: 20, alignItems: 'center', gap: 12 }}>
          <Button variant='contained' disabled={!canOpenConsultation} onClick={onOpenConsultation}>
            공개논평 개설
          </Button>
          {renderOpenConsultationCaption() && (
            <Typography variant='caption' color='text.secondary'>
              {renderOpenConsultationCaption()}
            </Typography>
          )}
          {renderApprovalGateCaption() && (
            <Typography variant='caption' color='text.secondary'>
              {renderApprovalGateCaption()}
            </Typography>
          )}
          <Button
            variant='contained'
            color={isViewRegistry ? 'secondary' : 'primary'}
            disabled={!status}
            onClick={() => onToggleRegistry(!isViewRegistry)}
          >
            {isViewRegistry ? '등록부 공개 해제' : '등록부 공개'}
          </Button>
          {!status && (
            <Typography variant='caption' color='text.secondary'>
              정식 승인 후 등록부에 공개할 수 있습니다
            </Typography>
          )}
        </div>
      )}
    </article>
  );
};
